import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layouts/app-layout/app-layout';
import { authGuard, noAuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'auth/login',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./pages/auth/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'auth/forgot-password',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'auth/reset-password',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: 'digilocker-complete',
    loadComponent: () =>
      import('./pages/digilocker-complete/digilocker-complete.page').then(
        (m) => m.DigilockerCompletePage,
      ),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'tenants/builders',
        loadComponent: () =>
          import('./pages/tenants/builders/builders.page').then((m) => m.BuildersPage),
      },
      {
        path: 'tenants/builders/:workspaceId/subdomain',
        loadComponent: () =>
          import('./pages/tenants/tenant-subdomain-configuration.page').then(
            (m) => m.TenantSubdomainConfigurationPage,
          ),
      },
      {
        path: 'tenants/channel-partners',
        loadComponent: () =>
          import('./pages/tenants/channel-partners/channel-partners.page').then(
            (m) => m.ChannelPartnersPage,
          ),
      },
      {
        path: 'subscription/catalog',
        loadComponent: () =>
          import('./pages/subscription/catalog/catalog.page').then((m) => m.CatalogPage),
      },
      {
        path: 'subscription/module-groups',
        loadComponent: () =>
          import('./pages/subscription/module-groups/module-groups.page').then(
            (m) => m.ModuleGroupsPage,
          ),
      },
      {
        path: 'subscription/features',
        loadComponent: () =>
          import('./pages/subscription/features/features.page').then(
            (m) => m.FeaturesPage,
          ),
      },
      {
        path: 'subscription/addons',
        loadComponent: () =>
          import('./pages/subscription/addons/addons.page').then((m) => m.AddonsPage),
      },
      {
        path: 'subscription/plans',
        loadComponent: () =>
          import('./pages/subscription/plans/plans.page').then((m) => m.PlansPage),
      },
      {
        path: 'financial/invoices',
        loadComponent: () =>
          import('./pages/financial/invoices/invoices.page').then((m) => m.InvoicesPage),
      },
      {
        path: 'financial/payments',
        loadComponent: () =>
          import('./pages/financial/payments/payments.page').then((m) => m.PaymentsPage),
      },
      {
        path: 'financial/receipts',
        redirectTo: 'financial/payments',
        pathMatch: 'full',
      },
      {
        path: 'governance',
        loadComponent: () =>
          import('./pages/governance/governance.page').then((m) => m.GovernancePage),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
